import FormTable from './FormTable/FormTable'
import ModalIndexCard from './ModalIndexCard/ModalIndexCard'
import AdvancedTabs from './AdvancedTabs/AdvancedTabs'

export const FormTablePage = FormTable;
export const ModalIndexCardPage = ModalIndexCard;
export const AdvancedTabsComponent = AdvancedTabs;
